import { type CSSProperties, forwardRef } from "react";
import { Icons } from "widgets";
import type { GetArrayElementType } from "widgets/utils";

import { TileStatus } from "@/modules/core/components/settings.ts";
import { Tile } from "@/modules/core/components/Tile.tsx";
import { ENTITY_TYPE } from "@/settings/settings.ts";
import { SampleLockedIcon } from "@/ui-modules/core/tiles/components/SampleTile.tsx";
import type { GetMinimalSampleTilesQuery } from "@/ui-modules/entities/samples/graphql/samples-queries.gql.ts";

export interface SampleTileProps {
  sample: MinimalSampleTileInfo;
  style?: CSSProperties;
  forceExternal?: boolean;
}
export type MinimalSampleTileInfo = GetArrayElementType<
  NonNullable<NonNullable<GetMinimalSampleTilesQuery["sample"]>["samples"]>
>;

export const MinimalSampleTile = forwardRef<HTMLDivElement, SampleTileProps>(function SampleTile(props, ref) {
  const sample = props.sample;

  return (
    <Tile
      title={sample?.name ?? ""}
      icon={<img src={Icons.Tiles.Sample} width={24} height={30} alt={"sample icon"} />}
      type={sample?.type?.name}
      protectionStatus={
        sample.deleted ? TileStatus.Deleted : sample.hidden ? TileStatus.RestrictedVisibility : TileStatus.Normal
      }
      to={`/${ENTITY_TYPE.SAMPLE}/${sample.id}`}
      ref={ref}
      style={props.style}
      forceExternal={props.forceExternal}
      titleTrailer={sample?.locked ? <SampleLockedIcon size={15} /> : null}
    />
  );
});

export interface MicroSampleTileProps {
  sample: MinimalSampleTileInfo;
  style?: CSSProperties;
  forceExternal?: boolean;
}

export const MicroSampleTile = forwardRef<HTMLDivElement, SampleTileProps>(function SampleTile(props, ref) {
  const sample = props.sample;

  return (
    <Tile
      title={sample?.name ?? ""}
      icon={<img src={Icons.Tiles.Sample} width={16} height={24} alt={"sample icon"} />}
      iconWidth={16}
      protectionStatus={
        sample.deleted ? TileStatus.Deleted : sample.hidden ? TileStatus.RestrictedVisibility : TileStatus.Normal
      }
      to={`/${ENTITY_TYPE.SAMPLE}/${sample.id}`}
      ref={ref}
      style={props.style}
      forceExternal={props.forceExternal}
      titleTrailer={sample?.locked ? <SampleLockedIcon size={15} /> : null}
    />
  );
});
